<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateMeterReadings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      name="createOptions"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="notes"
        :label="'Notes'|pgettext('CreateMeterReadings')"
      >
        <ItpFormTextarea
          name="notes"
          v-model="notes"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
      <ItpFormGroup
        name="irentWriteback"
        :description="'Save values to the legacy database, too.'|pgettext('CreateMeterReadings')"
        row
        label-cols-md="0"
        content-cols-md="12"
      >
        <ItpFormCheckbox
          name="irentWriteback"
          v-model="irentWriteback"
          :label="'IntegroRent writeback'|pgettext('CreateMeterReadings')"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="irentWriteback"
        :description="'Skip writeback to the legacy database if the serial number is not found in the legacy database.'|pgettext('GenerateMeterReading')"
        row
        label-cols-md="0"
        content-cols-md="12"
      >
        <ItpFormCheckbox
          name="irentWritebackSkipMetersNotFound"
          v-model="irentWritebackSkipMetersNotFound"
          :label="'IntegroRent writeback - skip not found'|pgettext('CreateMeterReadings')"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="skipMetersNotFound"
        :description="'Skip meters not found in the database.'|pgettext('CreateMeterReadings')"
        row
        label-cols-md="0"
        content-cols-md="12"
      >
        <ItpFormCheckbox
          name="skipMetersNotFound"
          v-model="skipMetersNotFound"
          :label="'Skip not found'|pgettext('CreateMeterReadings')"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.createOptions && forms.createOptions.id"
      :text="'Create Readings'|pgettext('MeterMeasurementGenerateButton')"
      type="submit"
      variant="primary"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|pgettext('CreateMeterReadings')"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateMeterReadings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    default: null,
  })
  items!: list;

  @Watch('items')
  onItems(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("items")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  notes!: any;
  irentWriteback!: any;
  skipMetersNotFound!: any;
  irentWritebackSkipMetersNotFound!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['notes', 'irentWriteback', 'skipMetersNotFound', 'irentWritebackSkipMetersNotFound', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        notes: null,
        irentWriteback: false,
        skipMetersNotFound: false,
        irentWritebackSkipMetersNotFound: false,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("CreateMeterReadings", "Create Meter Readings"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7804_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7804, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_register_7810_getActionArgs($event: actions.ActionEvent): Promise<actions.RegisterActionArgs> {
    // parameterResolver name=act_1040167445267876_register_7810, alias=undefined
    return {
      name: "resultLength",
      value: $event.data.response.data ? $event.data.response.data.length : 0,
    }
  }

  async act_1040167445267876_notification_7812_getActionArgs($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_1040167445267876_notification_7812, alias=undefined
    return {
      message: this.$fn.ngettext("One meter reading created.", "${n} meter readings created.", $event.data.resultLength),
    }
  }

  async act_1040167445267876_notification_7812_getWhen($event: actions.ActionEvent): Promise<actions.NotificationActionArgs> {
    // parameterResolver name=act_1040167445267876_notification_7812, alias=undefined
    return $event.data.resultLength > 0
  }

  async act_1040167445267876_closeModal_7814_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_7814, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_reloadSlickgrid_7816_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_7816, alias=undefined
    return {
      grid: "all",
    }
  }

  async act_1040167445267876_request_7808_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_7808, alias=submit
    return {
      operation: "create_meter_reading",
      data: this.items
        .filter(p => !!p.meter_id)
        .map(p => ({
          meter_id: p.meter_id,
          value: p.value,
          unit: p.unit,
          notes: this.notes,
          reading_type: 'automated',
          reading_date: this.$fn.formatDate(this.$fn.parseISODate(p.timestamp), 'yyyy-MM-dd'),
          reading_time: this.$fn.formatDate(this.$fn.parseISODate(p.timestamp), 'hh:mm'),
        })),
      parameters: {
        "irent-writeback": this.irentWriteback,
        "skip-meters-not-found": this.skipMetersNotFound,
        "irent-writeback-skip-meters-not-found": this.irentWritebackSkipMetersNotFound,
      }
      ,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7804: actions.CloseModalAction;
    evh_7315092382398562_close_7803: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_7806: actions.CloseComponentAction;
    evh_2248226175642056_close_7805: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_register_7810: actions.RegisterAction;
    evh_1040167445267876_success_7809: actions.EventHandlerImpl;
    act_1040167445267876_notification_7812: actions.NotificationAction;
    evh_1040167445267876_success_7811: actions.EventHandlerImpl;
    act_1040167445267876_closeModal_7814: actions.CloseModalAction;
    evh_1040167445267876_success_7813: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_7816: actions.ReloadSlickgridAction;
    evh_1040167445267876_success_7815: actions.EventHandlerImpl;
    act_1040167445267876_request_7808: actions.RequestAction;
    evh_1040167445267876_submit_7807: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_7818: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_7817: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7804 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7804_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7803 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7804,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7803],
      }
    );
    const act_2248226175642056_closeComponent_7806 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_7805 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_7806,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_7805],
      }
    );
    const act_1040167445267876_register_7810 = new actions.RegisterAction(
      {
        actionArgs: this.act_1040167445267876_register_7810_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_7809 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_register_7810,
        event: "success",
        displayName: "register",
      }
    );
    const act_1040167445267876_notification_7812 = new actions.NotificationAction(
      {
        actionArgs: this.act_1040167445267876_notification_7812_getActionArgs,
        when: this.act_1040167445267876_notification_7812_getWhen,
        events: [],
      }
    );
    const evh_1040167445267876_success_7811 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_notification_7812,
        event: "success",
        displayName: "notification",
      }
    );
    const act_1040167445267876_closeModal_7814 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_7814_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_7813 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_7814,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_reloadSlickgrid_7816 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_7816_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_7815 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_7816,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_request_7808 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_7808_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_7809, evh_1040167445267876_success_7811, evh_1040167445267876_success_7813, evh_1040167445267876_success_7815],
      }
    );
    const evh_1040167445267876_submit_7807 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_7808,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_7807],
      }
    );
    const act_1419464017721962_closeComponent_7818 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_7817 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_7818,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_7817],
      }
    );
    return {
      act_7315092382398562_closeModal_7804,
      evh_7315092382398562_close_7803,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_7806,
      evh_2248226175642056_close_7805,
      evh_2248226175642056_close,
      act_1040167445267876_register_7810,
      evh_1040167445267876_success_7809,
      act_1040167445267876_notification_7812,
      evh_1040167445267876_success_7811,
      act_1040167445267876_closeModal_7814,
      evh_1040167445267876_success_7813,
      act_1040167445267876_reloadSlickgrid_7816,
      evh_1040167445267876_success_7815,
      act_1040167445267876_request_7808,
      evh_1040167445267876_submit_7807,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_7818,
      evh_1419464017721962_clickPreventStop_7817,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_request_7808,
    }
  }
}

Vue.component("CreateMeterReadings", CreateMeterReadings);

</script>